import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";

export const IRREPLACEABLE_AREAS: Layer = {
  id: "irreplacable_areas",
  layerType: ConstraintsLayerType,
  title: "Irreplaceable ancient woodland",
  requiredFeatureAccess: [Feature.planningPolicyLayer],
  toggleable: true,
  group: LayerGroup.POLICY,
  icon: "lt-tree-line",
  description: "Protected trees and woodland",
  hideByDefault: true,
  zoomConfig: {
    minVisualisationZoom: 10,
  },
  layerConfig: {
    rootCategory: ConstraintsCategory.ANCIENT_WOODLAND,
    categorySchema: [{ key: "ancient_woodland" }],
  },
};
